import type { TowerShipment } from "../../../types/controlTower";

// Tono con que se pinta un envío (marcadores, etiquetas y listas). Todo lo
// reprogramado va en gris, como "Reprogramado por el comprador": también
// "Reprogramado por meli" (delayed) y "Reprogramado" a secas, que se cuenta
// como incidencia pero no es una ausencia. El rojo queda para nadie, ausente,
// no entregado y demorado.
export function statusTone(shipment: Pick<TowerShipment, "status" | "rawStatus">): string {
  if (shipment.status === "delayed") return "rescheduled";
  if (shipment.status === "incident" && /REPROGRAM/i.test(shipment.rawStatus || "")) return "rescheduled";
  return shipment.status;
}

// Texto de la etiqueta: "Reprogramado" en vez de "Incidencia" para ese caso.
export function statusText(shipment: Pick<TowerShipment, "status" | "rawStatus" | "statusLabel">): string {
  return shipment.status === "incident" && statusTone(shipment) === "rescheduled"
    ? "Reprogramado"
    : shipment.statusLabel;
}
